import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';
import {
  BsTelephoneFill,
  BsWhatsapp,
  BsEnvelopeFill,
  BsGeoAltFill,
} from "react-icons/bs";

function Mumbaitoayodhyacab() {



const cardData = {
  keyword: " Mumbai to Ayodhya Cab",

headingDescription:
  "Omshree Cab offers reliable and comfortable Mumbai to Ayodhya cab services for travelers embarking on a spiritual journey, family trip, or long‑distance travel between Maharashtra and Uttar Pradesh. Whether you are planning a pilgrimage to Ayodhya, attending family functions, or simply exploring one of India’s most sacred cities, our taxi service ensures a smooth, safe, and hassle‑free journey with professional drivers and well‑maintained vehicles. We provide flexible booking options including one‑way rides, round‑trip packages, and multi‑day travel plans with transparent per‑kilometer pricing. Our fleet includes air‑conditioned sedans, spacious SUVs, luxury cars, and tempo travelers suitable for solo travelers, families, and groups. With experienced chauffeurs skilled in long‑distance highway routes, punctual pickups from anywhere in Mumbai, and 24/7 customer support, Omshree Cab is your trusted partner for dependable cab services from Mumbai to Ayodhya.",

topPlaces: [
  {
    title: "Ram Janmabhoomi Temple",
    description:
      "Ram Janmabhoomi Temple in Ayodhya is one of the most revered pilgrimage sites in India, believed to be the birthplace of Lord Rama. Pilgrims and devotees visit to offer prayers, participate in rituals, and experience the deep spiritual atmosphere surrounding this sacred site. A cab journey from Mumbai to Ayodhya allows travelers to reach this holy destination comfortably and plan sufficient time for darshan and rituals without the stress of multiple transport changes."
  },
  {
    title: "Hanuman Garhi",
    description:
      "Hanuman Garhi is a famous temple in Ayodhya dedicated to Lord Hanuman, known for its spiritual significance and panoramic views of the city. Visitors often climb steps to reach the elevated temple and enjoy peaceful surroundings, especially at sunrise and sunset. Traveling by cab provides a comfortable ride from Mumbai to Ayodhya and flexibility to include this devotional stop in your pilgrimage itinerary."
  },
  {
    title: "Kanak Bhawan",
    description:
      "Kanak Bhawan is a historic temple in Ayodhya associated with Lord Rama and Goddess Sita, featuring beautiful architecture and sacred idols. Devotees visit to offer prayers, explore the temple complex, and experience the serene spiritual environment. A long‑distance cab service from Mumbai ensures convenient access and flexible timing for visiting this revered location as part of your Ayodhya trip."
  },
  {
    title: "Sita Ki Rasoi",
    description:
      "Sita Ki Rasoi is a historic kitchen site in Ayodhya believed to be linked to Goddess Sita during her time in the city. The location holds cultural and religious significance for pilgrims and history enthusiasts. Traveling by cab allows visitors to comfortably explore this heritage spot and include it in their full Ayodhya tour without the need for local transport hassles."
  },
  {
    title: "Nageshwarnath Temple",
    description:
      "Nageshwarnath Temple in Ayodhya has deep mythological importance and is dedicated to Lord Shiva. Visitors come to seek blessings, admire the stone architecture, and experience the temple’s peaceful ambiance. A cab ride from Mumbai to Ayodhya provides flexibility in timing and sightseeing options, making it easy to visit multiple temples and spiritual sites in one trip."
  },
  {
    title: "Ram Ki Paidi (Ghats of Sarayu)",
    description:
      "Ram Ki Paidi are sacred ghats along the Sarayu River in Ayodhya where pilgrims gather to take holy dips, perform rituals, and enjoy scenic views of the river. Early mornings and evenings are especially serene for spiritual walks and meditation. Traveling by cab ensures comfortable access to these riverfront ghats and allows travelers to plan ample time for spiritual activities."
  },
  {
    title: "Treta Ke Thakur",
    description:
      "Treta Ke Thakur is a significant temple believed to be connected to events of the Treta Yuga and holds importance in Hindu mythology. Visitors come here to offer prayers, seek blessings, and immerse themselves in the spiritual environment. A long‑distance cab service from Mumbai makes it convenient to include this temple in your Ayodhya pilgrimage itinerary without concerns about local transport."
  },
  {
    title: "Ayodhya Museum",
    description:
      "Ayodhya Museum offers insights into the city’s history, culture, and archaeological discoveries, showcasing artifacts, sculptures, and exhibits related to Ayodhya’s heritage. Travelers interested in understanding the city’s rich past can explore the museum at leisure. A cab journey from Mumbai allows you to combine spiritual visits with cultural exploration in Ayodhya."
  },
  {
    title: "Dashrath Mahal",
    description:
      "Dashrath Mahal is an architectural heritage site in Ayodhya associated with King Dashrath and features elegant domes and historic structures. Visitors can admire its design, take photographs, and immerse themselves in the city’s historical ambiance. Traveling by cab provides flexibility to explore heritage spots and plan a comprehensive sightseeing itinerary."
  },
  {
    title: "Local Ayodhya Markets",
    description:
      "Ayodhya’s local markets offer a variety of religious souvenirs, traditional items, handicrafts, and regional delicacies. Visitors often enjoy shopping for puja items, gifts, and souvenirs to take home after their pilgrimage. A cab service from Mumbai ensures convenient travel to and from the city, making it easy to include shopping and local culture experiences in your trip."
  }
],



services: [
{
name: "Mumbai to Ayodhya Cab",
description: "Mumbai to Ayodhya cab service provides comfortable long-distance transportation for devotees and travelers visiting the holy city of Ayodhya. The journey connects Maharashtra to Uttar Pradesh through major national highways, making it ideal for spiritual travel and tourism. Professional drivers ensure safe driving and punctual pickup services from homes, hotels, offices, railway stations, and airport terminals across Mumbai. Vehicles are well maintained and suitable for long-distance highway travel. Spacious seating ensures comfortable journeys for families and groups. Flexible booking options allow convenient travel planning."
},
{
name: "Mumbai to Ayodhya Taxi",
description: "Mumbai to Ayodhya taxi service offers reliable transportation for devotees visiting the sacred city known for the Shri Ram Janmabhoomi temple. Vehicles are designed for long-distance highway travel and provide comfortable seating and luggage space. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals. Ideal for pilgrimage travel, family trips, and temple tours. Air-conditioned vehicles ensure comfortable journeys. Flexible booking options allow easy taxi reservations."
},
{
name: "Mumbai to Ayodhya Cab Service",
description: "Mumbai to Ayodhya cab service offers dependable transportation for travelers planning spiritual journeys to Ayodhya. Vehicles are suitable for interstate travel and long-distance highway routes. Professional drivers ensure safe driving and punctual pickup services across Mumbai. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for religious tours, family vacations, and pilgrimage travel. Comfortable vehicles ensure relaxed journeys throughout the trip. Flexible booking options allow convenient cab reservations."
},
{
name: "Mumbai to Ayodhya Taxi Service",
description: "Mumbai to Ayodhya taxi service provides convenient travel options for devotees visiting the holy city of Lord Ram. Vehicles are well maintained and suitable for long-distance journeys across multiple states. Professional drivers ensure safe driving and punctual pickup services across Mumbai. Pickup services are available from homes, offices, hotels, railway stations, and airports. Ideal for pilgrimage tours, temple visits, and family travel. Air-conditioned vehicles ensure comfortable journeys. Flexible booking options allow convenient taxi scheduling."
},
{
name: "Cab from Mumbai to Ayodhya",
description: "Cab from Mumbai to Ayodhya provides reliable interstate transportation for travelers planning spiritual or tourism journeys. Vehicles offer comfortable seating and smooth highway performance suitable for extended travel. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals. Ideal for family pilgrimages, tourism travel, and corporate journeys. Spacious vehicles ensure comfortable long-distance travel. Flexible booking options allow easy ride reservations."
},
{
name: "Taxi from Mumbai to Ayodhya",
description: "Taxi from Mumbai to Ayodhya offers convenient transportation for devotees traveling to the famous Ram Mandir and other temples in Ayodhya. Vehicles are suitable for highway travel and provide comfortable seating for long-distance journeys. Professional drivers ensure safe driving and punctual pickup services across Mumbai. Pickup services are available from homes, hotels, offices, railway stations, and airports. Ideal for pilgrimage tours and family trips. Air-conditioned vehicles ensure comfortable travel experiences. Flexible booking options allow easy taxi reservations."
},
{
name: "Mumbai to Ayodhya Cab Booking",
description: "Mumbai to Ayodhya cab booking allows travelers to easily reserve vehicles for interstate pilgrimage journeys. Online and phone booking options provide instant confirmations and convenient ride scheduling. Professional drivers ensure safe driving and punctual pickup services across Mumbai. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals. Ideal for temple visits, spiritual journeys, and tourism travel. Comfortable vehicles ensure relaxed travel experiences. Flexible booking options allow easy reservations."
},
{
name: "Mumbai to Ayodhya Taxi Booking Online",
description: "Mumbai to Ayodhya taxi booking online provides convenient ride reservations through digital platforms. Travelers can easily schedule pickups and receive instant confirmations for their pilgrimage journeys. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals. Ideal for families, devotees, and corporate travelers. Air-conditioned vehicles ensure comfortable journeys. Flexible online booking options allow easy travel planning."
},
{
name: "Mumbai to Ayodhya Cab Price",
description: "Mumbai to Ayodhya cab price options provide transparent fare estimates for passengers planning long-distance journeys. Pricing depends on vehicle type, travel distance, and trip duration. Professional drivers ensure safe driving and punctual pickup services across Mumbai. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals. Ideal for family travel, pilgrimage tours, and tourism visits. Comfortable vehicles ensure relaxed journeys. Transparent pricing ensures affordable travel planning."
},
{
name: "Mumbai to Ayodhya Taxi Fare",
description: "Mumbai to Ayodhya taxi fare services offer flexible pricing options depending on vehicle category and travel duration. Travelers can choose from sedan, SUV, and MPV vehicles based on comfort and budget. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for long-distance travel, pilgrimage tours, and tourism visits. Comfortable interiors ensure relaxed journeys. Transparent fare structure allows easy travel planning."
},
{
name: "Mumbai to Ayodhya One Way Cab",
description: "Mumbai to Ayodhya one way cab service offers economical intercity transportation without return charges. Vehicles provide comfortable seating and smooth highway performance for long-distance travel. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals. Ideal for pilgrims and travelers visiting Ayodhya temple. Air-conditioned vehicles ensure comfortable journeys. Flexible booking options allow quick ride reservations."
},
{
name: "Mumbai to Ayodhya Round Trip Taxi",
description: "Mumbai to Ayodhya round trip taxi service provides convenient transportation for travelers planning return journeys. Vehicles are suitable for long-distance highway travel and multi-day trips. Professional drivers ensure safe driving and punctual pickup services across Mumbai. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals. Ideal for family pilgrimages, temple tours, and tourism travel. Comfortable vehicles ensure relaxed journeys. Flexible round-trip packages allow convenient travel planning."
},
{
name: "Mumbai to Ayodhya Temple Tour Cab",
description: "Mumbai to Ayodhya temple tour cab service provides convenient transportation for devotees visiting major temples and spiritual places in Ayodhya. Vehicles are suitable for long-distance pilgrimage journeys and group travel. Professional drivers ensure safe driving and punctual pickup services across Mumbai. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals. Ideal for religious tours and spiritual travel. Comfortable interiors ensure relaxed journeys throughout the trip. Flexible booking options allow customized temple tours."
},
{
name: "Ayodhya Ram Mandir Cab from Mumbai",
description: "Ayodhya Ram Mandir cab from Mumbai provides reliable transportation for devotees visiting the sacred Ram Janmabhoomi temple. Vehicles offer comfortable seating and smooth highway performance suitable for long-distance travel. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals. Ideal for pilgrimage travel and family temple visits. Air-conditioned vehicles ensure comfortable journeys. Flexible booking options allow easy ride reservations."
},
{
name: "Religious Tour Cab Ayodhya",
description: "Religious tour cab to Ayodhya from Mumbai provides convenient transportation for spiritual travelers visiting temples and sacred sites in Ayodhya. Vehicles are suitable for long-distance pilgrimage journeys across states. Professional drivers ensure safe driving and punctual pickup services across Mumbai. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals. Ideal for temple tours, spiritual journeys, and family pilgrimage travel. Comfortable vehicles ensure relaxed travel experiences. Flexible booking options allow customized religious travel planning."
}
],

tableData: [
["Mumbai to Ayodhya Cab","Mumbai to Ayodhya Taxi"],
["Mumbai to Ayodhya Cab Service","Mumbai to Ayodhya Taxi Service"],
["Cab from Mumbai to Ayodhya","Taxi from Mumbai to Ayodhya"],
["Mumbai to Ayodhya Cab Booking","Mumbai to Ayodhya Taxi Booking Online"],
["Mumbai to Ayodhya Cab Price","Mumbai to Ayodhya Taxi Fare"],
["Mumbai to Ayodhya One Way Cab","Mumbai to Ayodhya Round Trip Taxi"],
["Mumbai to Ayodhya Temple Tour Cab","Ayodhya Ram Mandir Cab from Mumbai"],
["Religious Tour Cab Ayodhya","Ayodhya Pilgrimage Cab Service"]
],



whychoose: [
  {
    WhyChooseheading: "Experienced Long-Distance Drivers",
    WhyChoosedescription: "Our drivers are highly experienced in interstate travel from Mumbai to Ayodhya. They are familiar with long highway routes across multiple states and ensure safe and comfortable travel during the long-distance journey."
  },
  {
    WhyChooseheading: "Transparent Cab Pricing",
    WhyChoosedescription: "Omshree Cabs offers transparent pricing for Mumbai to Ayodhya cab services. Customers receive complete fare details including per-kilometer charges, tolls, and driver allowance before confirming the booking."
  },
  {
    WhyChooseheading: "24/7 Cab Booking Service",
    WhyChoosedescription: "Our Mumbai to Ayodhya cab service is available 24 hours a day. Whether you want to start early in the morning or travel overnight, we provide reliable cab booking anytime."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles in our fleet are well maintained, regularly cleaned, and fully air-conditioned to ensure a comfortable journey for passengers traveling long distances."
  },
  {
    WhyChooseheading: "Flexible One-Way & Round Trip Packages",
    WhyChoosedescription: "We offer flexible travel options including one-way cab booking, round-trip travel, and multi-day tour packages from Mumbai to Ayodhya for pilgrims and tourists."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Omshree Cabs provides a wide range of vehicles including sedan cars, SUVs like Ertiga and Innova, luxury vehicles like Innova Crysta, and Tempo Travellers suitable for families and groups."
  },
  {
    WhyChooseheading: "Doorstep Pickup Across Mumbai",
    WhyChoosedescription: "We provide convenient pickup from homes, hotels, offices, railway stations, and airports anywhere in Mumbai so your Ayodhya journey begins smoothly."
  },
  {
    WhyChooseheading: "Trusted Pilgrimage Cab Service",
    WhyChoosedescription: "Omshree Cabs is trusted by many travelers and devotees visiting Shri Ram Mandir Ayodhya. Our professional drivers, comfortable vehicles, and reliable service ensure a peaceful pilgrimage journey."
  }
]
};

const faqData = [
  { question: "Do you provide cab service from Mumbai to Ayodhya?", answer: "Yes, Omshree Cabs provides reliable cab services from Mumbai to Ayodhya for pilgrimage and tourism travel." },
  { question: "What is the distance from Mumbai to Ayodhya?", answer: "The distance from Mumbai to Ayodhya is approximately 1500 km and the journey usually takes around 24 to 26 hours depending on road and traffic conditions." },
  { question: "Can I book a one-way cab from Mumbai to Ayodhya?", answer: "Yes, we offer both one-way and round-trip cab services for travel between Mumbai and Ayodhya." },
  { question: "Which vehicles are available for this route?", answer: "We provide sedan cars, SUVs like Ertiga and Innova, luxury vehicles like Innova Crysta, and Tempo Travellers depending on group size." },
  { question: "Is the cab service available 24 hours?", answer: "Yes, our Mumbai to Ayodhya cab service operates 24/7 for passenger convenience." },
  { question: "Are all vehicles air-conditioned?", answer: "Yes, all vehicles provided by Omshree Cabs are fully air-conditioned for comfortable long-distance travel." },
  { question: "Can we stop during the journey?", answer: "Yes, passengers can request stops during the journey for meals, rest, or sightseeing." },
  { question: "Is advance booking recommended?", answer: "Yes, advance booking is recommended for long-distance travel like Mumbai to Ayodhya." },
  { question: "Do you provide temple tour packages in Ayodhya?", answer: "Yes, we can arrange Ayodhya temple visit packages including Shri Ram Janmabhoomi Temple and other nearby religious places." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to maintain passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rajesh Sharma",
    feedback:
      "We booked Omshree Cabs for our pilgrimage from Mumbai to Ayodhya. The driver was very professional and the journey was comfortable.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Sunita Kulkarni",
    feedback:
      "Excellent long-distance cab service. Our trip from Mumbai to Ayodhya was smooth with a clean vehicle and reliable driver.",
    rating: 5
  }
];











































const Images = [
  { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cab" },
{ place: "/images/keyword/2.jpeg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
{ place: "/images/keyword/5.jpeg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
{ place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
{ place: "/images/keyword/7.jpeg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
{ place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
{ place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
{ place: "/images/keyword/11.jpeg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
{ place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
{ place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
{ place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
{ place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
{ place: "/images/keyword/16.jpeg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
{ place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
{ place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
{ place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
{ place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
{ place: "/images/keyword/21.jpeg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
{ place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
];












const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Ayodhya Cab",
  "description": "Omshree Cab provides reliable cab services from Mumbai to Ayodhya for one-way and round trips. Travel comfortably for religious tours, including visits to Ram Mandir and other temple destinations, with Innova, Sedan, and SUV options. Enjoy safe, punctual, and convenient journeys with transparent pricing and flexible booking options.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1200"
  }
};





  return (
    <div>
      
<Helmet>
  <title>Mumbai to Ayodhya Cab | Contact: +91 9892544084 | Omshree Cab</title>
  <meta 
    name="description" 
    content="Omshree Cab offers cab services from Mumbai to Ayodhya for one-way and round trips. Ideal for religious tours, including Ram Mandir visits, with Innova, Sedan, and SUV vehicles. Safe, punctual, and convenient travel with flexible booking options." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/62.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Omshree Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚙
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Omshree Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Omshree Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
       <div className="pc-contact">
      <h4 className="pc-title">Contact Information</h4>

      <div className="pc-grid">
        {/* Phones */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsTelephoneFill className="pc-icon" />
            <span>Phone Numbers</span>
          </header>

          <div className="pc-list">
            <a href="tel:+919892544084" className="pc-call">
              +91 9892544084
            </a>
          </div>

          <div className="pc-cta">
            <a
              href="https://wa.me/919892544084"
              target="_blank"
              rel="noopener noreferrer"
              className="pc-whats"
            >
              <BsWhatsapp /> WhatsApp
            </a>

            <a href="tel:+919892544084" className="pc-primary">
              Call Now
            </a>
          </div>
        </section>

        {/* Email */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsEnvelopeFill className="pc-icon" />
            <span>Email</span>
          </header>

          <a href="mailto:booking@omshreecabs.com" className="pc-email">
            booking@omshreecabs.com
          </a>
        </section>

        {/* Address */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsGeoAltFill className="pc-icon" />
            <span>Address</span>
          </header>

          <address className="pc-address">
            <strong>Omshree Cab</strong>
            <br />
           Shri Omkar Co-op Housing Society,
            <br />
            E-11/101, Sector 9,
Ghansoli (Gharonda),
            <br />
            Navi Mumbai, Maharashtra, India - 400701
          </address>
        </section>
      </div>
    </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitoayodhyacab;